export default __webpack_public_path__ + "static/dw-light-416d3c05577bcdb13ba9d12cfed45a71.png";